import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import * as dashboardService from '../../service/dashboard.service'
import { MemberDashboardSummary } from "../../service/model/dashboard.model";

export interface MemberDashboardState {
    isLoading: boolean;
    summary?: MemberDashboardSummary;
}
  
export const initialState = ({
    isLoading: false,
} as MemberDashboardState);

export const fetchMemberDashboardSummary = createAsyncThunk<MemberDashboardSummary>(
    'dashboard/member',
    async (_, {rejectWithValue}) => {
        return dashboardService.getMemberDashboardSummary().catch((errors) => {
            return rejectWithValue(errors);
        })
    }
);

const memberDashboardSlice = createSlice({
    name: 'memberDashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchMemberDashboardSummary.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(fetchMemberDashboardSummary.fulfilled, (state, action: PayloadAction<MemberDashboardSummary>) => {
            state.summary = action.payload;
            state.isLoading = false;
        })
        .addCase(fetchMemberDashboardSummary.rejected, (state) => {
            state.isLoading = false;
        })
    }
});

export const selectIsLoading = (state: RootState) => state.memberDashboard.isLoading;
export const selectMemberDashboardSummary = (state: RootState) => state.memberDashboard.summary;

export default memberDashboardSlice.reducer;